import React, { useContext, useState } from "react";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Divider from "@mui/material/Divider";
import IconButton from "@mui/material/IconButton";
import Settings from "@mui/icons-material/Settings";
import Logout from "@mui/icons-material/Logout";
import { authStore } from "../../../features/auth/store/AuthStore";
import HeadsetMicOutlinedIcon from "@mui/icons-material/HeadsetMicOutlined";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { LangSelect } from "../../molecules/LangSelect";
import { useTranslation } from "react-i18next";

const supportUrl = "https://t.me/unlimsmm_support_bot";

export const ProfileMenu = () => {
  const { t } = useTranslation();
  const { user, logout } = useContext(authStore);

  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const capitalizeFirstLetter = (string: string | undefined) => {
    if (!string) {
      return;
    }
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  return (
    <Box sx={{ display: "flex" }}>
      <LangSelect />
      <IconButton
        onClick={() => {
          window.open(supportUrl, "_blank");
        }}
        size="small"
      >
        <Avatar
          sx={{
            width: 40,
            height: 40,
            backgroundColor: "lightGrey",
          }}
        >
          <HeadsetMicOutlinedIcon />
        </Avatar>
      </IconButton>

      <Box sx={{ display: "flex", alignItems: "center", textAlign: "center" }}>
        <IconButton onClick={handleClick} size="small">
          <Avatar
            sx={{
              width: 40,
              height: 40,
              backgroundColor: "rgb(158, 119, 237)",
            }}
            src={user?.username}
            alt={user?.username[0].toLocaleUpperCase()}
          ></Avatar>
        </IconButton>
      </Box>
      <Menu
        anchorEl={anchorEl}
        id="account-menu"
        open={open}
        onClose={handleClose}
        onClick={handleClose}
        transformOrigin={{ horizontal: "right", vertical: "top" }}
        anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
      >
        <MenuItem
          onClick={handleClose}
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "start",
          }}
        >
          <Typography>{capitalizeFirstLetter(user?.username)}</Typography>
          <Typography
            sx={{ color: "rgb(108, 115, 127)", fontSize: "0.875 rem" }}
          >
            {user?.email}
          </Typography>
        </MenuItem>
        <Divider />
        <MenuItem onClick={handleClose}>
          <Link
            to={"/account"}
            style={{
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              color: "black",
            }}
          >
            <ListItemIcon>
              <AccountCircleIcon fontSize="small" />
            </ListItemIcon>
            {t("account.account")}
          </Link>
        </MenuItem>
        <MenuItem onClick={handleClose}>
          <Link
            to={"/settings"}
            style={{
              textDecoration: "none",
              display: "flex",
              alignItems: "center",
              color: "black",
            }}
          >
            <ListItemIcon>
              <Settings fontSize="small" />
            </ListItemIcon>
            {t("settings")}
          </Link>
        </MenuItem>
        <MenuItem onClick={logout}>
          <ListItemIcon>
            <Logout fontSize="small" />
          </ListItemIcon>
          {t("logout")}
        </MenuItem>
      </Menu>
    </Box>
  );
};
